export const THEME_STORAGE_KEY = 'orcaAi.theme';

/** @returns {'light' | 'dark'} */
export function getStoredTheme() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    // ignore quota / private mode
  }
  return 'dark';
}

const THEME_COLORS = {
  dark: '#000103',
  light: '#f8fafc',
};

/** @param {'light' | 'dark'} theme */
export function applyTheme(theme) {
  const resolved = theme === 'light' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', resolved);
  document.documentElement.classList.add('orca-theme');
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', THEME_COLORS[resolved]);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, resolved);
  } catch {
    // ignore quota / private mode
  }
  return resolved;
}

/** Apply persisted theme (call once before React mount). */
export function initTheme() {
  return applyTheme(getStoredTheme());
}

/** @param {'light' | 'dark'} current */
export function toggleTheme(current) {
  return applyTheme(current === 'light' ? 'dark' : 'light');
}
